import { Component } from '@angular/core';

@Component({
  templateUrl: './accessibility-statement.component.html',
})
export class AccessibilityStatementComponent {}
